var map = {
	"./about-myskoolbus.jpg": 1220,
	"./aboutus.jpg": 2241,
	"./bus.png": 3544,
	"./default-benefit.svg": 2115,
	"./favicon.ico": 2647,
	"./for-parents.png": 9927,
	"./for-schools.png": 2395,
	"./forschool-1.jpg": 6369,
	"./forschool-11.jpg": 1808,
	"./forschool-2.jpg": 4166,
	"./forschool-21.jpg": 3033,
	"./forschool-3.jpg": 4275,
	"./forschool-31.jpg": 1230,
	"./forschool-4.jpg": 5472,
	"./forschool-41.jpg": 359,
	"./forschool-5.jpg": 365,
	"./forschool-51.jpg": 8020,
	"./forschool-6.jpg": 1138,
	"./forschool-61.jpg": 8365,
	"./forschool-7.jpg": 2847,
	"./forschool-71.jpg": 8658,
	"./forschool-8.jpg": 5100,
	"./forschool-81.jpg": 6843,
	"./mobile.png": 4222,
	"./notification.gif": 2982,
	"./notification1-1.png": 9338,
	"./notification1.png": 4324,
	"./notification10-1.png": 7396,
	"./notification11.png": 3927,
	"./notification2-1.png": 5801,
	"./notification2.png": 7535,
	"./notification3-1.png": 8252,
	"./notification3.png": 4246,
	"./notification4-1.png": 995,
	"./notification4.png": 4329,
	"./notification5-1.png": 8110,
	"./notification5.png": 6208,
	"./notification6-1.png": 7325,
	"./notification7-1.png": 9808,
	"./notification7.png": 3362,
	"./notification8-1.png": 7207,
	"./notification8.png": 565,
	"./notification9-1.png": 2386,
	"./notification9.png": 8300,
	"./story.jpg": 2661,
	"./testimonial-1.jpg": 7277,
	"./testimonial-2.jpg": 8050,
	"./testimonial-3.jpg": 6111,
	"./testimonial-4.jpg": 1476,
	"./who-we-are.png": 8652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5870;